module.exports = __webpack_public_path__ + "img/20191112152713654.cbbb846e.jpg";